export enum PageRoutes {
   CONTROL_PANEL = "/control-panel",
   FLOOR_OVERVIEW = "/floor-overview",
   WEARABLES_OVERVIEW = "/reassureband-overview",
   DEMO = "/demo",
   LOGIN = "/login",
   MFA_REQUIRED = "/mfa-required",
   ENTRA_CALLBACK = "/entra/callback",
   NEW_PASSWORD = "/new-password",
   PASSWORD_RECOVERY = "/password-recovery",
   SETTINGS = "/settings",
   PREFERENCES = "/preferences",
   CELL_DETAIL_OVERVIEW = "/cell-detail-overview",
   INMATE_DETAIL_OVERVIEW = "/inmate-detail-overview",
}

export enum SettingsRoutes {
   FACILITY_LEVELS = "/settings/facility-levels",
   FACILITY = "/settings/facility",
   LOCATIONS = "/settings/locations",
   CELLS = "/settings/cells",
   INMATES = "/settings/inmates",
   USERS = "/settings/users",
   ALERTS = "/settings/alarms",
   ALERTS_DETAIL = "/settings/alarms/:id",
   GENERAL = "/settings/general",
   OPEN_CELL_SCHEDULES = "/settings/open-cell-schedules",
}

export enum CellDetailOverviewRoutes {
   SUMMARY = "/cell-detail-overview/:id/summary",
   ALERT_SETTINGS = "/cell-detail-overview/:id/alarm-settings/:alarmId",
   EXPORT = "/cell-detail-overview/:id/export",
   OPEN_CELL_SCHEDULES = "/cell-detail-overview/:id/open-cell-schedules",
}

export enum InmateDetailOverviewRoutes {
   SUMMARY = "/inmate-detail-overview/:id/summary",
   EXPORT = "/inmate-detail-overview/:id/export",
}
